const fixAndFlipInterestRate = 10.25;

export default fixAndFlipInterestRate;
